module.exports = __webpack_public_path__ + "static/img/userule2.18ffeab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userule2.jpg
// module id = weVM
// module chunks = 0